import React from "react";

export default function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="glow orb-1"></div>
        <div className="glow orb-2"></div>
        <div className="grid-lines"></div>
      </div>

      <div className="hero-inner">
        <div className="hero-copy">
          <p className="eyebrow">CREATING INFINITY POSSIBILITIES</p>
          <h1>
            Lead generation built for
            <span> high-intent growth.</span>
          </h1>
          <p className="lead">
            We are a lead generation company helping brands scale with social
            media strategy, personal branding, SEO, GEO optimization, and paid
            media across Google Ads and Meta Ads.
          </p>
          <div className="hero-actions">
            <a className="btn primary" href="#contact">
              Book a Growth Call
            </a>
            <a className="btn ghost" href="#contact">
              View Case Studies
            </a>
          </div>
          <div className="hero-metrics">
            <div>
              <strong>120+</strong>
              <span>Campaigns shipped</span>
            </div>
            <div>
              <strong>4.8x</strong>
              <span>Average ROAS</span>
            </div>
            <div>
              <strong>9</strong>
              <span>Industries served</span>
            </div>
          </div>
        </div>

        <div className="hero-media">
          <div className="media-card">
            <div className="media-top">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
            <div className="media-body">
              <div className="media-line"></div>
              <div className="media-line short"></div>
              <div className="media-mock">
                <img src="/hero.webp" alt="Lead generation and digital growth dashboard mockup" />
              </div>
              <div className="media-line"></div>
              <div className="media-line short"></div>
            </div>
          </div>
          <div className="media-card floating">
            <p>UGC Ads</p>
            <strong>+312% CTR</strong>
          </div>
        </div>
      </div>
    </section>
  );
}
